/**
 * Module-level singleton for the AppLayout action bar portal target.
 *
 * AppLayout behaves as a singleton (mounts once, stays mounted), so a
 * module-level store is a legitimate alternative to React context here —
 * analogous to Angular singleton services.
 */

type Listener = () => void;

let _container: HTMLElement | null = null;
const _listeners = new Set<Listener>();

export function setActionBarContainer(el: HTMLElement | null): void {
  _container = el;
  _listeners.forEach((listener) => listener());
}

export function getActionBarContainer(): HTMLElement | null {
  return _container;
}

export function subscribeActionBarContainer(listener: Listener): () => void {
  _listeners.add(listener);
  return () => {
    _listeners.delete(listener);
  };
}
